import { Slider } from '@mui/material';
import PriceChangeIcon from '@mui/icons-material/PriceChange';

export const PriceRangeFilter = ({
  priceRange,
  handleSliderChange,
  minRangePrice,
  maxRangePrice,
  handleInputChange,
  // handleBlur,
  background,
  isLoading,
}) => {
  // Ensure values are always defined
  const minValue = minRangePrice ?? priceRange[0] ?? 0;
  const maxValue = maxRangePrice ?? priceRange[1] ?? 0;

  return (
    <>
      <div className='filter-section flex items-center flex-col'>
        <div className='w-full'>
          <div className='flex items-center gap-2 mb-3'>
            <PriceChangeIcon
              className='w-5 h-5'
              sx={{ color: isLoading ? '#9CA3AF' : background }}
            />
            <h3 className={`font-medium ${isLoading ? 'text-gray-400' : 'text-gray-700'}`}>
              Rango de Precio
            </h3>
          </div>
        </div>
        <Slider
          disabled={isLoading}
          max={priceRange[1]}
          min={priceRange[0]}
          onChange={handleSliderChange}
          sx={{
            maxWidth: '90%',
            display: 'flex',
            alignSelf: 'center',
            color: background,
            '& .MuiSlider-thumb': {
              backgroundColor: background,
            },
            '& .MuiSlider-track': {
              backgroundColor: background,
            },
            '& .MuiSlider-rail': {
              opacity: 0.35,
            },
          }}
          value={[minValue, maxValue]}
          valueLabelDisplay='off'
        />
        <div className='mt-4 flex gap-4'>
          <input
            disabled={isLoading}
            type='text'
            value={minValue}
            onChange={(e) => handleInputChange(e, 'minPrice')}
            // onBlur={handleBlur}
            className='flex-1 w-full pl-2 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 text-sm'
          />
          <input
            disabled={isLoading}
            placeholder={maxValue}
            type='text'
            value={maxValue}
            onChange={(e) => handleInputChange(e, 'maxPrice')}
            // onBlur={handleBlur}
            className='flex-1 w-full pl-2 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 text-sm'
          />
        </div>
      </div>
    </>
  );
};
